import MenuMainModule from './menu-main.module'

export default MenuMainModule
